import React, { useId } from 'react'
import { Pill } from '../../../../shared/sso-workspace/pill'
import { levelsFor } from './grant-words'
import './api-keys.scss'

// The per-resource grid (contract §8): one row per resource group content
// offers here, each a radio group of No access / Read / Read and write (only
// the levels that group has; Courses is read-only). These are a form's
// choices laid out as rows, so it is plain markup, not a data grid. `value`
// is { groupID: level }; a choice hands back the whole grid with that group
// changed. EducationXR's own resource (platform_only) says so. `disabled`
// locks every choice (a form that is saving: what is sent stays what is shown).
export const GrantsGrid = ({ groups, value, onChange, labelledBy, disabled = false }) => {
  const prefix = useId()
  return (
    <div className="ak-grants" role="group" aria-labelledby={labelledBy}>
      {(groups || []).map(group => {
        const nameID = `${prefix}-${group.id}`
        const level = (value && value[group.id]) || 'none'
        return (
          <div key={group.id} className="ak-grant-row">
            <div className="ak-grant-name">
              <span id={nameID} className="fw-semibold">{group.label}</span>
              {group.platform_only && <Pill tone="info" title="Only a key of EducationXR's own organization can hold this, given by EducationXR staff.">EducationXR only</Pill>}
              {group.description && <span className="sw-hint small ak-role-help">{group.description}</span>}
            </div>
            <div className="ak-choices ak-choices-inline" role="radiogroup" aria-labelledby={nameID}>
              {levelsFor(group).map(choice =>
                <label key={choice.value}>
                  <input type="radio" name={nameID} checked={level === choice.value} disabled={disabled} onChange={() => onChange({ ...(value || {}), [group.id]: choice.value })} />
                  {choice.label}
                </label>)}
            </div>
          </div>
        )
      })}
    </div>
  )
}
